import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../App";

const IconBrowse = ({ active }) => active ? (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1H15v-5h-6v5H4a1 1 0 01-1-1V10.5z" fill="#1a2744"/>
  </svg>
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 10.5L12 3l9 7.5V20a1 1 0 01-1 1H15v-5h-6v5H4a1 1 0 01-1-1V10.5z" stroke="#aaa" strokeWidth="1.5" fill="none"/>
  </svg>
);

const IconListings = ({ active }) => active ? (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="3" rx="1.5" fill="#1a2744"/>
    <rect x="3" y="10.5" width="12" height="3" rx="1.5" fill="#1a2744"/>
    <rect x="3" y="16" width="15" height="3" rx="1.5" fill="#1a2744"/>
  </svg>
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect x="3" y="5" width="18" height="3" rx="1.5" stroke="#aaa" strokeWidth="1.5"/>
    <rect x="3" y="10.5" width="12" height="3" rx="1.5" stroke="#aaa" strokeWidth="1.5"/>
    <rect x="3" y="16" width="15" height="3" rx="1.5" stroke="#aaa" strokeWidth="1.5"/>
  </svg>
);

const IconSell = ({ active }) => active ? (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" fill="#1a2744"/>
    <path d="M12 8v8M8 12h8" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="#aaa" strokeWidth="1.5"/>
    <path d="M12 8v8M8 12h8" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const IconProfile = ({ active }) => active ? (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="7" r="4" fill="#1a2744"/>
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#1a2744" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="7" r="4" stroke="#aaa" strokeWidth="1.5" fill="none"/>
    <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, setShowPost } = useApp();

  const items = [
    { path: "/", icon: IconBrowse, label: t.browse },
    { path: "/my-listings", icon: IconListings, label: t.myListings },
    { action: () => setShowPost(true), icon: IconSell, label: t.sell },
    { path: "/profile", icon: IconProfile, label: t.profile },
  ];

  return (
    <nav className="bottom-nav">
      {items.map((item, i) => {
        const isActive = item.path && location.pathname === item.path;
        const Icon = item.icon;
        return (
          <button
            key={i}
            className={`nav-item ${isActive ? "active" : ""}`}
            onClick={() => item.path ? navigate(item.path) : item.action()}
          >
            <Icon active={isActive} />
            <span className="nav-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
